import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { themeName } from './helper/Enums/enums.enum';
import { themes } from './helper/Enums/theme.const';
import { GlobalService } from './helper/Services/global.service';
import { SecureStorage } from './helper/Services/secure-storage';
import { ThemeService } from './helper/Services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
 // styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  STUrl: any;
  language: any;
  title = 'StatusTracker';
  favicon;
  ipAddress: any;
  constructor(
    private themService: ThemeService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private secureStorage: SecureStorage,
    private gservce: GlobalService,
    @Inject(DOCUMENT) private document: any
  ) { }

  async ngOnInit(): Promise<any> {
    this.cookieService.delete('userSelectedLanguage');
    this.STUrl = window.location.href;
    if (EnvSetting.language.LanguageOverRule) {
      this.translate.setDefaultLang(EnvSetting.language.LanguageOverRuleDefault);
      this.translate.use(EnvSetting.language.LanguageOverRuleDefault);
    }
    else {
      const currentLang= this.gservce.customerDefaultLanguage ?? EnvSetting.STATUSTRACKER_DEFAULT_LANGUAGE_CONFIG;
      this.translate.setDefaultLang(currentLang); 
      this.translate.use(currentLang);
     }
    this.applyTheme();
  }

  private applyTheme() {
    this.themService.setActiveThem(this.findTheme());
  }

  private findTheme(): string {
    const faviconUrl = themes['sytnerTheme'].favicon;
    if(this.document.getElementById('favicon')){
      this.document.getElementById('favicon').setAttribute('href', faviconUrl);
    }
    return themeName.SytnerTheme;
  }

  private isCookiesExist(): boolean {
    return this.cookieService.check('userSelectedLanguage');
  }
}

